import styled, { css } from "styled-components";
import colors from "../../shared/constants/color";
import { getWiserTheme } from "../../shared/theme/wiserTheme";
import { themeGet } from "@styled-system/theme-get";

export const StyledContentContainer = styled.div<{ darkModeActive: boolean }>`
  background-color: ${({ darkModeActive }) =>
    darkModeActive ? "transparent" : "white"};
  border-radius: 8px;

  ${({ darkModeActive }) =>
    darkModeActive &&
    css`
      color: ${getWiserTheme(true).textPrimary};
      background: ${getWiserTheme(true).surface};
      border: 1px solid ${getWiserTheme(true).border};
      border-radius: 16px;
      backdrop-filter: blur(10px);
      box-shadow: ${getWiserTheme(true).surfaceShadow};
      padding: 16px;
      transition: color 0.2s ease, background 0.2s ease, border-color 0.2s ease;
    `}
`;

export const StyledLink = styled.a<{ $darkModeActive?: boolean }>`
  font-family: ${themeGet("fonts.interUi")};
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: ${({ $darkModeActive }) =>
    $darkModeActive ? getWiserTheme(true).textMuted : colors.neutral.N200};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
    color: ${({ $darkModeActive }) =>
      $darkModeActive ? getWiserTheme(true).textSecondary : colors.neutral.N200};
  }
`;
